import {
    api_admin_helmets_del,
    api_admin_helmets_patch,
    api_admin_helmets_post,
    Helmet,
    HelmetExtension,
} from 'abi'
import { addAlert, setPopup } from 'components'
import {
    CheckFillIcon,
    CloseIcon,
    DeleteIcon,
    PrinterIcon,
    WarningIcon,
} from 'icons'

import { Component, createEffect, createMemo, on, Show } from 'solid-js'
import { createStore, produce, unwrap } from 'solid-js/store'
import { deepcopy, objentries } from 'utils/tools'
import { CORP_INSURANCE_STATE } from '.'

import {
    ExcelLoading,
    ExcelStatus,
    FileSec,
    HELMET_STATE_TYPE,
    ManuSec,
} from 'pages/panel/insurances/addIns'
import SelectedHelmets from 'pages/panel/insurances/select'
import { cState } from '../shared'
import './style/corpadd.scss'

interface addInsProps {
    add: CORP_INSURANCE_STATE['add']

    onClose(): void

    onAdd(c: Helmet[]): void
    onDel(c: Helmet): void
    onEdit(c: Helmet): void
    onPrint(c: Helmet): void
    onExtentionPrint(c: HelmetExtension): void
}
type STATE = HELMET_STATE_TYPE & {
    loading: boolean
    status: null | 'green' | 'red'

    sec: 'file' | 'manual'

    anim: boolean
}

export const AddInsCmp: Component<addInsProps> = P => {
    const [state, setState] = createStore<STATE>({
        loading: false,
        status: null,

        sec: 'file',

        anim: false,

        loadingXls: '',
        rows: [],
        // cols: 0,
        helmets: [],
        // get view_cols() {
        //     let out: CellValue[][] = []
        //     for (let cdx = 0; cdx < this.cols; cdx++) {
        //         let col: CellValue[] = []
        //         for (let r of this.rows) {
        //             if (r[cdx] == undefined) break
        //             col.push(r[cdx]!)
        //         }
        //         out.push(col)
        //     }
        //     return out
        // },

        select: {
            show: false,
            selected: [],
        },

        stat: [-1, -1],
    })
    createEffect(
        on(
            () => P.add.show,
            s => {
                if (!s) return closed()

                if (P.add.type == 'edit') {
                    setState({
                        loading: false,
                        loadingXls: '',
                        status: null,

                        sec: 'manual',

                        helmets: [deepcopy(P.add.ins!)],
                    })
                    return
                }

                // similar to init
                closed()
            }
        )
    )

    const closed = () => {
        setState({
            loading: false,
            status: null,

            sec: 'file',

            anim: false,

            loadingXls: '',
            rows: [],
            // cols: 0,
            helmets: [],

            select: {
                show: false,
                selected: [],
            },
        })
    }

    type COMPARE_T = Omit<Helmet, 'id'>
    const keys: (keyof COMPARE_T)[] = [
        'cargo',
        'vin',
        'insurance_number',
        'expiration_date',
        'issuer_code',
        'airrm_cover_life',
        'plate_city',
        'added_toll',
        'chassis',
        'engine',
        'plate_serial',
        'issue_year',
        'manufacture_year',
        'passenger_count',
        'print_count',
        'provider',
        'third_party_insurance_amount',
        'v_group',
        'v_usage',
        'insurer_code',
        'added_tax',
        'issuer',
        'airrm_cover_financial',
        'company',
        'created_at',
        'fund_fine',
        'airrm_cover_passenger',
        'issue_time',
        'economic_number',
        'v_color',
        'v_system',
        'issue_date',
        'start_date',
        'reagent',
        'passenger_insurance_amount',
        'unique_code',
        'life_surplus_insurance_amount',
        'v_name',
        'total_insurance_amount',
        'financial_surplus_insurance_amount',
        'insurer_phone',
        'insurance_code',
        'past_insurer',
        'past_expiration_date',
        'insurer',
        'plate_number',
    ]
    const changed = createMemo(() => {
        if (P.add.type == 'add') {
            let change_xls = state.rows.length !== 0
            let change_manu = state.helmets.length !== 0

            return change_xls || change_manu
        } else {
            const h = state.helmets[0] as Partial<COMPARE_T> | undefined
            const p = P.add.ins as Partial<COMPARE_T> | undefined

            if (!h && !p) return false

            if (!h || !p) return true

            if (h.company !== p.company) return true

            return keys.some(k => {
                const a = h[k]
                const b = p[k]

                if (a == null && b == null) return false

                return String(a ?? '') !== String(b ?? '')
            })
        }
    })

    const patchHelmet = async () => {
        if (state.loading || state.loadingXls || state.status) return

        if (!changed()) {
            addAlert({
                type: 'error',
                timeout: 3,
                subject: 'مطلبی را عوض نکردید!',
            })
            return
        }

        let id = P.add.ins?.id

        if (!id) return console.log(P.add.ins)

        let h = deepcopy(state.helmets[0]!)

        setState({ loading: true })

        const payload: Partial<Helmet> = { ...h, company: cState.corp!.id }

        let res = await api_admin_helmets_patch({ id }, payload as any)

        setState({ loading: false })

        if (!res.ok()) return setState('status', 'red')

        setState('status', 'green')
        P.onEdit(res.body)
    }
    const addHelmets = async () => {
        if (state.loading || state.loadingXls || state.status) return

        if (!changed()) {
            addAlert({
                type: 'error',
                timeout: 3,
                subject: 'مطلبی را عوض نکردید!',
            })
            return
        }

        if (state.helmets.length == 0) {
            addAlert({
                type: 'error',
                timeout: 3,
                subject: 'خطا!',
                content: 'در فایل آپلودی، اطلاعات بیمه‌ای یافت نشد!',
            })
            return
        }

        setState({ loading: true })

        setState(
            produce(s => {
                s.stat = [0, state.helmets.length]
            })
        )
        let uploadPromises = state.helmets.map(async (h, idx) => {
            const payload: Partial<Helmet> = { ...h, company: cState.corp!.id }

            return api_admin_helmets_post(payload as any).then(res => {
                if (!res.ok()) {
                    addAlert({
                        type: 'error',
                        subject: `خطا در ردیف ${idx}`,
                        content: res.body.debug || '',
                        timeout: 3,
                    })
                    throw new Error('')
                }

                setState(
                    produce(s => {
                        s.helmets[idx]!['id'] = res.body.id
                        s.stat[0] = s.stat[0] + 1
                    })
                )
                return
            })
        })

        await Promise.all(uploadPromises)
            .then(() => {
                pop_conffeties()
                setState('status', 'green')
                P.onAdd(state.helmets)
            })
            .catch(() => {
                setState('status', 'red')
            })
            .finally(() => {
                setState('loading', false)
            })
    }

    const delIns = async () => {
        if (state.loading || state.loadingXls || !!state.status)
            return console.log('object')

        let id = P.add.ins?.id

        if (!id) return console.log(P.add.ins)

        setState({ loading: true })

        let res = await api_admin_helmets_del({ id })

        setState({ loading: false })

        if (!res.ok()) return setState('status', 'red')
        setState('status', 'green')
        P.onDel(P.add.ins!)
        return
    }

    const pop_conffeties = () => {
        // @ts-ignore
        if (typeof window.confetti !== 'function') return

        const count = 200,
            defaults = {
                origin: { y: 0.7 },
            }

        function fire(particleRatio: number, opts: any) {
            // @ts-ignore
            window.confetti(
                Object.assign({}, defaults, opts, {
                    particleCount: Math.floor(count * particleRatio),
                })
            )
        }

        fire(0.25, {
            spread: 26,
            startVelocity: 55,
        })

        fire(0.2, {
            spread: 60,
        })

        fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 45,
        })
    }

    const OnClose = () => {
        if (state.status == 'red')
            return setState({ loading: false, status: null })

        if (state.loading) return

        if (changed() && !state.status) {
            setPopup({
                show: true,
                title: 'ذخیره نکردید!',
                content: 'بعد از خروج، تغییرات شما اعمال نمیشوند!',
                Icon: WarningIcon,
                type: 'warning',
                onSubmit: P.onClose,
            })
            return
        }

        P.onClose()
    }

    return (
        <div
            class='corp-add-ins-cmp'
            classList={{ show: P.add.show }}
            onclick={OnClose}
        >
            <div
                class='add-ins-wrapper'
                onclick={e => {
                    e.stopPropagation()
                }}
            >
                <div
                    class='scaler'
                    onanimationend={() => setState({ anim: true })}
                ></div>

                <button class='close icon' type='button' onclick={OnClose}>
                    <CloseIcon />
                </button>

                <form
                    onsubmit={e => {
                        e.preventDefault()

                        if (P.add.type == 'add') {
                            addHelmets()
                        } else {
                            patchHelmet()
                        }
                    }}
                    class='card'
                >
                    <Show when={P.add.type == 'add'}>
                        <div
                            class='sec-picker title_smaller'
                            classList={{ active: state.sec == 'manual' }}
                        >
                            <button
                                type='button'
                                class='file'
                                onclick={() => setState('sec', 'file')}
                            >
                                فایل
                            </button>
                            <button
                                type='button'
                                class='manu'
                                onclick={() => setState('sec', 'manual')}
                            >
                                دستی
                            </button>
                        </div>
                    </Show>

                    <div class='sec-ctas title_smaller'>
                        <button
                            class='sec-cta save'
                            type='submit'
                            classList={{ active: changed() }}
                        >
                            <CheckFillIcon />
                            ذخیره
                        </button>

                        <Show when={P.add.type == 'edit'}>
                            <button
                                class='sec-cta del'
                                onclick={() => {
                                    setPopup({
                                        show: true,
                                        Icon: DeleteIcon,
                                        type: 'error',
                                        title: 'بیمه رو حذف میکنید؟',
                                        content:
                                            'بعد از حذف امکان بازگشت وجود ندارد!',
                                        onSubmit: delIns,
                                    })
                                }}
                                type='button'
                            >
                                <DeleteIcon />
                                حذف
                            </button>
                            <button
                                class='sec-cta print'
                                type='button'
                                classList={{ active: changed() }}
                                onclick={() => P.onPrint(P.add.ins!)}
                            >
                                <PrinterIcon />
                                پرینت
                            </button>
                        </Show>
                    </div>

                    <div class='secs-container'>
                        <Show when={P.add.type == 'add'}>
                            <FileSec
                                corpPick={false}
                                add={P.add}
                                state={state}
                                setState={setState}
                            />
                        </Show>

                        <ManuSec
                            corpPick={false}
                            add={P.add}
                            state={state}
                            setState={setState}
                            onExtPrint={c => P.onExtentionPrint(c)}
                        />
                    </div>

                    <Show when={state.select.show}>
                        <SelectedHelmets
                            pickCorp={false}
                            count={state.select.selected.length}
                            show={state.select.show}
                            onClose={() => setState('select', 'show', false)}
                            onSave={h => {
                                let list = unwrap(state.select.selected)

                                list.map(id => {
                                    let idx = state.helmets.findIndex(
                                        hel => hel.id == id
                                    )
                                    if (idx == -1) return

                                    let trues: Partial<Helmet> = {}

                                    for (let [k, v] of objentries(h)) {
                                        if (!v) continue
                                        if (
                                            typeof v == 'string' &&
                                            v.trim().length == 0
                                        )
                                            continue

                                        trues[k] = v as any
                                    }

                                    setState('helmets', idx, prev => ({
                                        ...prev,
                                        ...trues,
                                    }))
                                })
                                setState({
                                    select: {
                                        show: false,
                                        selected: [],
                                    },
                                })
                            }}
                        />
                    </Show>
                </form>

                <ExcelLoading add={P.add} state={state} setState={setState} />

                <ExcelStatus add={P.add} state={state} setState={setState} />
            </div>
        </div>
    )
}
